import { globalAxios } from "@/axios-path.js";
//fetchPromotionReport
export default {
  namespaced: true,
  state: {
    clone_config_path: {
      datetime_start: null,
      datetime_end: null,
      district_id: [0],
    },
    config_path: {
      datetime_start: null,
      datetime_end: null,
      district_id: [0],
    },
    promotion_report_summary: {},
    promotion_report_list: [],
    export_promotion_format: [],
  },
  mutations: {
    resetState(state) {
      state.clone_config_path = {
        datetime_start: null,
        datetime_end: null,
        district_id: [0],
      };
      state.config_path = {
        datetime_start: null,
        datetime_end: null,
        district_id: [0],
      };
      state.promotion_report_summary = {};
      state.promotion_report_list = [];
      state.export_promotion_format = [];
    },
    fetchReportList(state, data) {
      state.promotion_report_list = data;
      let count_no = 1;
      for (let val of state.promotion_report_list) {
        val.no = count_no++;
        val.no_default = count_no - 1;
      }
    },
    getReportSummary(state, data) {
      state.promotion_report_summary = {
        total_value_price: 0,
        total_paid_price: 0,
      };
      for (let val of data) {
        state.promotion_report_summary.total_paid_price =
          state.promotion_report_summary.total_paid_price +
          val.total_paid_price;
        state.promotion_report_summary.total_value_price =
          state.promotion_report_summary.total_value_price +
          val.total_value_price;
      }
    },
    getExportReportForm(state) {
      state.export_promotion_format = [];
      for (let val of state.promotion_report_list) {
        let index = state.promotion_report_list.indexOf(val);
        let push_data = {
          No: index + 1,
          promotion_name: val.promotion_name,
          discount: val.discount,
          amount: val.amount,
          used_cancel: val.used_cancel,
          total_value_price: val.total_value_price
            ? parseFloat(val.total_value_price)
                .toFixed(2)
                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            : "0.00",
          total_paid_price: val.total_paid_price
            ? parseFloat(val.total_paid_price)
                .toFixed(2)
                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            : "0.00",
        };
        state.export_promotion_format.push(push_data);
      }
    },
    getExportSummaryForm(state) {
      if (state.export_promotion_format.length > 0) {
        let push_data = {
          promotion_name: "Total",
          total_value_price: state.promotion_report_summary.total_value_price
            ? parseFloat(state.promotion_report_summary.total_value_price)
                .toFixed(2)
                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            : "0.00",
          total_paid_price: state.promotion_report_summary.total_paid_price
            ? parseFloat(state.promotion_report_summary.total_paid_price)
                .toFixed(2)
                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            : "0.00",
        };
        state.export_promotion_format.push(push_data);
      }
    },
    cloneConfigPath(state) {
      state.clone_config_path = JSON.parse(JSON.stringify(state.config_path));
    },
  },
  actions: {
    async fetchReportList({ rootState, commit, state, dispatch }, config_path) {
      let url =
        rootState.api_urls.fetchPromotionReport_fetchReportList +
        config_path.datetime_start +
        "/" +
        config_path.datetime_end;
      let res = await dispatch("fetchGeneral/axiosPathGetData", url, {
        root: true,
      });
      if (typeof res == "boolean" && res == false) {
        return [];
      } else {
        commit("fetchReportList", res.data);
        commit("getReportSummary", res.data);
        commit("getExportReportForm");
        commit("getExportSummaryForm");
        commit("cloneConfigPath");
        return res;
      }
    },
    async fetchReportListByDistrict({ rootState, commit, state, dispatch }) {
      let url =
        "/api/v1/" +
        rootState.backOffice.province +
        "/search_by_district/promotion_report/datetime_start/datetime_end/" +
        state.config_path.datetime_start +
        "/" +
        state.config_path.datetime_end;
      let payload = {
        district: state.config_path.district_id,
      };
      return globalAxios
        .post(url, payload)
        .then((res) => {
          commit("fetchReportList", res.data);
          commit("getReportSummary", res.data);
          commit("getExportReportForm");
          commit("getExportSummaryForm");
          commit("cloneConfigPath");
          return res;
        })
        .catch((err) => {
          dispatch("disconnectNetwork", err, { root: true });
          return false;
        });
    },
  },
  getters: {},
};
